import axios from "axios";
import Env from '../runtimeEnv';

const API_URL = Env.REACT_APP_PYTHON_API_URL;

// Create an Axios instance with global settings
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Ensures cookies (including refresh_token) are sent
});

// Function to refresh the token
const refreshAccessToken = async () => {
  try {
    console.warn("[axiosInstance] Attempting to refresh token...");

    const response = await axios.post(`${API_URL}/api/refresh-token`, {}, { withCredentials: true });

    if (response.status === 200) {
      const { access_token } = response.data;

      // ✅ Store new access token in localStorage
      localStorage.setItem("access_token", access_token);

      // ✅ Update Axios default headers
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

      console.info("[axiosInstance] Token refreshed successfully.");
      return access_token;
    }
  } catch (error) {
    console.error("[axiosInstance] Token refresh failed:", error);
    return null;
  }
};

// Axios response interceptor to handle expired tokens
axiosInstance.interceptors.response.use(
  (response) => response, // ✅ Pass successful responses
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("[axiosInstance] Access token expired, refreshing...");

      const newAccessToken = await refreshAccessToken();

      if (newAccessToken) {
        // ✅ Retry the failed request with the new access token
        error.config.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstance(error.config);
      } else {
        console.error("[axiosInstance] Redirecting to login due to refresh failure.");
        window.location.href = "/"; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
